import { handleActions } from 'redux-actions';

export default handleActions(
	{
		FETCH_BANNER_FULFILLED: (state, action) => ({
			...state,
			...action.payload,
		}),
	},
	{
		id: -1,
		subTitle: '',
		title: '',
		url: '',
		createdAt: null,
		updatedAt: null,
	},
);



// WEBPACK FOOTER //
// ./src/reducers/banner.js